var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffMember(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4593_6242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6781 23.3575V21.0377C25.6773 20.0097 25.3352 19.0111 24.7053 18.1986C24.0755 17.3861 23.1937 16.8058 22.1983 16.5488",
    stroke: "#136773",
    strokeWidth: 2.31983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7186 23.3579V21.0381C18.7186 19.8076 18.2298 18.6275 17.3597 17.7574C16.4896 16.8873 15.3094 16.3984 14.0789 16.3984H4.79959C3.56907 16.3984 2.38895 16.8873 1.51885 17.7574C0.648741 18.6275 0.15992 19.8076 0.15992 21.0381V23.3579",
    stroke: "#136773",
    strokeWidth: 2.31983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5587 2.63086C18.5567 2.88639 19.4413 3.46681 20.073 4.28062C20.7046 5.09443 21.0475 6.09533 21.0475 7.12554C21.0475 8.15574 20.7046 9.15664 20.073 9.97045C19.4413 10.7843 18.5567 11.3647 17.5587 11.6202",
    stroke: "#136773",
    strokeWidth: 2.31983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43925 11.7598C12.0017 11.7598 14.0789 9.68255 14.0789 7.12014C14.0789 4.55772 12.0017 2.48047 9.43925 2.48047C6.87683 2.48047 4.79958 4.55772 4.79958 7.12014C4.79958 9.68255 6.87683 11.7598 9.43925 11.7598Z",
    stroke: "#136773",
    strokeWidth: 2.31983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4593_6242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.838,
    height: 27.838,
    fill: "white",
    transform: "translate(-1 -1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffMember);
export default __webpack_public_path__ + "static/media/staffMember.7ee11b3a64754fda02d021ed08996e77.svg";
export { ForwardRef as ReactComponent };